import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo, useState } from "react";
import { Popover, UnstyledButton, useMantineTheme, Text, } from "@mantine/core";
import { CloseX } from "./assets/icons.generated";
import { TEXT_COLOR } from "./theme/colors";
const InteractiveTooltip = ({ target, children, ...rest }) => {
    const [opened, setOpened] = useState(false);
    const theme = useMantineTheme();
    return (_jsxs(Popover, { position: "top", withArrow: true, shadow: "md", arrowSize: 12, opened: opened, onChange: setOpened, width: 287, ...rest, children: [_jsx(Popover.Target, { children: _jsx(UnstyledButton, { onClick: () => setOpened((o) => !o), lh: 0, children: target }) }), _jsxs(Popover.Dropdown, { p: 20, bg: "strongOverlay.0", sx: { border: "unset" }, children: [_jsx(UnstyledButton, { sx: {
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }, p: 4, lh: 0, onClick: () => setOpened((o) => !o), children: _jsx(CloseX, { width: 8, height: 8, fill: theme.colors.invertedPrimaryText[0] }) }), _jsx(Text, { size: "xs", color: TEXT_COLOR.INVERTED_PRIMARY, align: "left", children: children })] })] }));
};
export default memo(InteractiveTooltip);
